import Card from '@/modules/benefit/components/card/card';
import { BENEFITS_SORT_MAPPING } from '@/modules/benefit/entities/constants/benefit';
import useBenefits from '@/modules/benefit/hooks/useBenefits/useBenefits';
import { useNegotiations } from '@/modules/negotiation';
import React from 'react';
import BoxInfo from '@/components/boxInfo/boxInfo';
import EmptyMessage from '@/components/emptyMessage';
import GridGroup from '@/components/gridGroup';

const BenefitsBox: React.FC = () => {
  const { getNegotiationsIdByBenefitId } = useNegotiations();
  const { isLoading, benefits } = useBenefits(BENEFITS_SORT_MAPPING);

  return (
    <BoxInfo title='Benefícios' icon='heart-outline'>
      {(isLoading || !!benefits?.length) && (
        <GridGroup
          body={
            isLoading
              ? Array.from({ length: 3 }).map(() => ({
                  component: <Card />,
                }))
              : benefits.map((benefit) => ({
                  component: (
                    <Card
                      benefit={benefit}
                      negotiations={benefit.id ? getNegotiationsIdByBenefitId(benefit.id) : []}
                    />
                  ),
                }))
          }
        />
      )}
      {!isLoading && !benefits?.length && <EmptyMessage title='Nenhum benefício encontrado' />}
    </BoxInfo>
  );
};

export default BenefitsBox;
